export default {
  activateRequest: "auth/activation/request",
  searchStudent: (id) => `student/search?no=${id}`,
  resend: "auth/activation/resendOTP",
  activateWithOtp: "auth/activation/otp",
  activate: (id) => `auth/activation/bc/${id}`,
  cancelActivation: (id) => `auth/activation/cancel/${id}`,
};
